import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataManipulationService } from '../../../services/data-manipulation.service';

@Component({
  selector: 'app-workspace-upgrade-modal',
  templateUrl: './workspace-upgrade-modal.component.html',
  styleUrls: ['./workspace-upgrade-modal.component.scss']
})
export class WorkspaceUpgradeModalComponent {
  creatorName: string = '';
  limitReachedDate: string = '';

  constructor(private dialogRef: MatDialogRef<any>, public data: DataManipulationService, private router: Router) {
    const creator = this.data.userRole?.workspace.creator;
    if (creator) {
      this.creatorName = this.data.getUserDisplayName(creator);
    }
    this.limitReachedDate = this.data.getDate(this.data.userRole?.workspace.limitReachedDate?.date ?? null);
  }

  close(result?: any) {
    this.dialogRef.close(result);
  }

  goToBilling() {
    this.close();
    this.data.lastRouteBeforeBilling = this.router.url;
    this.router.navigate(['/settings/billing']);
  }

  goToDashboard() {
    this.close();
    this.router.navigate(['/']);
  }
}
